export default "__VITE_ASSET__DntZAIlJ__"